import { FILTER_TYPES, PAGE_SIZE_FILTER } from 'constants/filterType';

export const PUT_AWAY_FILTER_OPTIONS = [
  {
    field: 'created_by__email__icontains',
    label: 'Created By',
    type: FILTER_TYPES.TEXT,
  },
  {
    field: 'is_completed',
    label: 'Completed',
    type: FILTER_TYPES.SELECT,
    options: [
      { value: '', label: 'All' },
      { value: 'true', label: 'Completed' },
      { value: 'false', label: 'Not Completed' },
    ],
  },
  { ...PAGE_SIZE_FILTER },
];
